// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__3t-VJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Backdrop/Backdrop.css
// module id = 887
// module chunks = 2